import { useContext } from "react";

import { NotificationContext } from "../context/notification.context";

export const useNotification = () => {
  const {
    addNotification,
    addNotifications,
    clearNotifications,
    notifications,
    removeNotification,
  } = useContext(NotificationContext);

  return {
    addNotification,
    addNotifications,
    clearNotifications,
    notifications,
    removeNotification,
  };
};
